import { __assign } from 'tslib';
import React__default from 'react';
import classNames from 'classnames';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { NvMarkdownInline, NvHeading } from '@invitae/ids-react';
import TeamGroup from './TeamGroup/TeamGroup.esm.js';
import styles from './TeamBlock.module.esm.js';

var TeamBlock = function (_a) {
    var _b = _a.fields, items = _b.items, heading = _b.heading, internalName = _b.internalName, analyticsEvents = _b.analyticsEvents, id = _a.id, dataCy = _a["data-cy"];
    return (React__default.createElement(BaseSectionWithAnalyticsContext, { analyticsEvents: analyticsEvents, className: classNames('nv-container', styles.wrapper), "data-cy": dataCy, id: id, sectionName: internalName },
        heading && (React__default.createElement(NvMarkdownInline, { className: styles.title, elementWrapper: NvHeading, level: 1 }, heading)),
        items.map(function (_a) {
            var fields = _a.fields, sys = _a.sys;
            return (React__default.createElement(TeamGroup, __assign({}, fields, { key: sys.id })));
        })));
};

export { TeamBlock as default };
//# sourceMappingURL=TeamBlock.esm.js.map
